import apiFetch from '../apiFetch'

export default function (token, uoId) {
  return apiFetch({ endPoint: `OrganizedUnit/GetSameLevelOus/${uoId}`, method: 'GET', body: null, token: token })
}
